import { render, staticRenderFns } from "./WaBtn.vue?vue&type=template&id=a20f85b2&scoped=true"
var script = {}
import style0 from "./WaBtn.vue?vue&type=style&index=0&id=a20f85b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20f85b2",
  null
  
)

export default component.exports